module.exports = __webpack_public_path__ + "img/file----------------------------1x-png@1x.fbbb51a1.png";